import React from 'react';
import { Badge, LabelDate } from '../../../../../../components';
import { PRESENTATION_STATUS_CONFIG } from '../../../constants';
import type { PresentationDto } from '../../../../../../services/presentations-management/models/PresentationDto';

interface PresentationMetadataProps {
  presentation: PresentationDto;
}

interface MetadataFieldProps {
  label: string;
  value: React.ReactNode;
  fullWidth?: boolean;
}

const MetadataField: React.FC<MetadataFieldProps> = ({
  label,
  value,
  fullWidth = false,
}) => (
  <div className={`flex items-center gap-2 ${fullWidth ? 'col-span-2' : ''}`}>
    <span className="text-tiny font-medium text-gray-500 whitespace-nowrap">
      {label}:
    </span>
    <div className="flex-1">{value}</div>
  </div>
);

export const PresentationMetadata: React.FC<PresentationMetadataProps> = ({
  presentation,
}) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-3">
      <div className="grid grid-cols-2 gap-4">
        <MetadataField
          label="Status"
          value={
            <Badge
              className="border border-inherit"
              config={PRESENTATION_STATUS_CONFIG}
              status={(presentation as any).status || 'UNKNOWN'}
            />
          }
        />
        {presentation.updatedAt && (
          <MetadataField
            label="Last Updated"
            value={
              <LabelDate
                date={presentation.updatedAt || ''}
                showTime
                className="text-tiny"
                formatDate="dd/MMM/yyyy"
              />
            }
          />
        )}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <MetadataField
          label="Total Slides"
          value={
            <p className="text-tiny text-gray-900">
              {presentation.slides?.length || 0}
            </p>
          }
        />
        <MetadataField
          label="Created At"
          value={
            <LabelDate
              date={presentation.createdAt || ''}
              showTime
              className="text-tiny"
              formatDate="dd/MMM/yyyy"
            />
          }
        />
      </div>
      {presentation.description && (
        <MetadataField
          label="Description"
          value={
            <p className="text-tiny text-gray-700">
              {presentation.description}
            </p>
          }
          fullWidth
        />
      )}
    </div>
  );
};
